const getParamFilterValue = (filter, value, add) => {
  const split = filter ? filter.split(',') : [];
  if (add) {
    if (!split.includes(value)) {
      split.push(value);
    }
  } else {
    const index = split.indexOf(value);
    split.splice(index, 1);
  }
  return split.join(',');
};

export default getParamFilterValue;
